import ProductPage from "./ProductPage";

const HERO_IMG_PERSON = "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?w=800";
const HERO_IMG_WOMAN = "https://images.pexels.com/photos/27086922/pexels-photo-27086922.jpeg?w=800";
const HERO_IMG_BUILDING = "https://images.unsplash.com/photo-1481026469463-66327c86e544?w=800&q=80";

export function PersonalFinancePage() {
  return (
    <ProductPage
      overline="Personal Finance"
      title="Guidance that respects"
      italicWord="your time and your goals."
      subtitle="Informational overviews of lending options for individuals. Request information to speak with a specialist about your situation."
      hero={{ image: HERO_IMG_WOMAN, alt: "Personal finance" }}
      columns={[
        { tag: "Info", title: "Personal Loans", desc: "Information about unsecured personal loans for common uses.", bullets: ["Debt consolidation guidance", "Home improvement options", "Emergency use cases"] },
        { tag: "Info", title: "Auto Financing", desc: "How new, used, and refinance auto financing typically works.", bullets: ["New & used vehicle", "Refinance basics", "Lease buyout"] },
        { tag: "Info", title: "Mortgages", desc: "Overview of common mortgage products and how to choose.", bullets: ["Fixed vs. adjustable", "FHA / VA basics", "Home equity options"] },
        { tag: "Info", title: "Student Loan Refinance", desc: "How consolidating federal & private loans usually works.", bullets: ["Refinancing basics", "Cosigner considerations", "Term-length trade-offs"] },
        { tag: "Info", title: "Debt Consolidation", desc: "How consolidation can simplify multiple payments.", bullets: ["Simplifying multiple debts", "Understanding APR", "Repayment scenarios"] },
        { tag: "Info", title: "Financial Education", desc: "Free resources to help you make informed decisions.", bullets: ["Repayment strategies", "Credit basics", "Budgeting fundamentals"] },
      ]}
    />
  );
}

export function BusinessFinancePage() {
  return (
    <ProductPage
      overline="Business Finance"
      title="Guidance for founders,"
      italicWord="operators, and CFOs."
      subtitle="Informational overviews of financing options for businesses. Request information to speak with a specialist about your situation."
      hero={{ image: HERO_IMG_PERSON, alt: "Business finance" }}
      columns={[
        { tag: "Info", title: "Small Business Loans", desc: "Overview of loan types typical for small businesses.", bullets: ["SBA program basics", "Working capital lines", "Equipment financing"] },
        { tag: "Info", title: "Commercial Lending", desc: "How commercial credit typically works for growing companies.", bullets: ["Term loans overview", "Line of credit basics", "Asset-backed structures"] },
        { tag: "Info", title: "Equipment Financing", desc: "Financing equipment purchases and upgrades.", bullets: ["Equipment loans", "Leasing options", "Trade-in scenarios"] },
        { tag: "Info", title: "SBA Programs", desc: "How Small Business Administration programs generally work.", bullets: ["SBA 7(a) basics", "SBA 504 basics", "Eligibility overview"] },
        { tag: "Info", title: "Cash-Flow Financing", desc: "Bridging revenue gaps through cash-flow-based options.", bullets: ["Invoice financing basics", "Working capital", "Bridge financing"] },
        { tag: "Info", title: "Startup Financing", desc: "How early-stage businesses often approach funding.", bullets: ["Founder-friendly options", "Common structures", "What lenders look for"] },
      ]}
    />
  );
}

export function LoansPage() {
  return (
    <ProductPage
      overline="Loan Programs"
      title="Information on terms"
      italicWord="you understand."
      subtitle="Transparent overviews of the loan program categories our partners specialize in. This page is informational only — not a credit application."
      hero={{ image: HERO_IMG_BUILDING, alt: "Loan programs" }}
      columns={[
        { tag: "Category", title: "Personal Loans", desc: "Uses include consolidation, home projects, medical costs, and more.", bullets: ["Common terms 36–84 months", "Amounts vary by partner", "Rates depend on credit"] },
        { tag: "Category", title: "Mortgages", desc: "Fixed, ARM, FHA, VA, Jumbo, and Home Equity information.", bullets: ["15/20/30-yr fixed", "ARM basics", "Home equity products"] },
        { tag: "Category", title: "Auto Loans", desc: "New, used, refinance, and lease buyout information.", bullets: ["New & used", "Refinance", "Lease buyout"] },
        { tag: "Category", title: "Student Loan Refinance", desc: "How refinancing federal & private loans typically works.", bullets: ["No origination fees at some partners", "Cosigner options", "5–20 year terms typical"] },
        { tag: "Category", title: "Small Business Loans", desc: "SBA, working capital, and equipment financing overviews.", bullets: ["SBA 7(a) & 504", "Working capital", "Equipment financing"] },
        { tag: "Category", title: "Home Equity", desc: "How tapping home equity for goals typically works.", bullets: ["HELOC vs. fixed", "LTV considerations", "Prequalification basics"] },
      ]}
    />
  );
}

export function InstitutionalLendingPage() {
  return (
    <ProductPage
      overline="Institutional Lending"
      title="Private credit,"
      italicWord="explained clearly."
      subtitle="Informational overviews of institutional lending categories. Request information to speak with a specialist."
      hero={{ image: HERO_IMG_BUILDING, alt: "Institutional lending" }}
      columns={[
        { tag: "Info", title: "Commercial Lending", desc: "Overviews of credit facilities for mid-market corporates.", bullets: ["ABL & cash-flow basics", "Multi-tranche capital", "Covenant considerations"] },
        { tag: "Info", title: "Corporate Financing", desc: "Growth capital, dividend recaps, and acquisition finance overviews.", bullets: ["Term loans overview", "Unitranche basics", "Delayed-draw structures"] },
        { tag: "Info", title: "Real Estate Investment", desc: "Bridge, construction, and permanent debt overviews.", bullets: ["CRE debt basics", "Bridge to construction", "Mezzanine overview"] },
        { tag: "Info", title: "Municipal Financing", desc: "How financing programs for public agencies typically work.", bullets: ["G.O. and revenue debt", "Refunding programs", "Direct placements"] },
        { tag: "Info", title: "Structured Finance", desc: "Warehouse lines, forward-flow, and asset-backed structures.", bullets: ["Warehouse basics", "Forward-flow overview", "SPV structuring"] },
        { tag: "Info", title: "Private Credit", desc: "Bespoke private-credit solutions for sponsors and family offices.", bullets: ["Sponsor-backed", "Non-sponsor", "Hold-size basics"] },
      ]}
    />
  );
}
